import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 pt-3 font-catering-body" }
const _hoisted_2 = { class: "flex items-center gap-3 rounded-catering-md border border-catering-cream-400 bg-catering-cream-200 p-4" }
const _hoisted_3 = { class: "min-w-0 flex-1" }
const _hoisted_4 = { class: "block font-catering-mono text-base text-catering-ink-900" }
const _hoisted_5 = { class: "block text-xs text-catering-ink-500" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center gap-3 rounded-catering-md border border-catering-lemon-600 bg-catering-lemon-100 p-4",
  role: "status"
}
const _hoisted_7 = {
  key: 1,
  class: "m-0 text-sm text-catering-berry-600"
}
const _hoisted_8 = {
  key: 2,
  class: "m-0 text-sm text-catering-ink-600"
}
const _hoisted_9 = {
  key: 3,
  class: "m-0 text-sm text-catering-berry-600"
}
const _hoisted_10 = { class: "flex items-center justify-end gap-4 pt-1" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 4,
  class: "m-0 text-xs leading-relaxed text-catering-ink-500"
}

import { UsersIcon } from '@heroicons/vue/24/outline'
import { computed, ref } from 'vue'
import { RouterLink } from 'vue-router'

import GlowFrame from '@/components/catering/GlowFrame.vue'
import SwooshArrow from '@/components/catering/SwooshArrow.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import { useSetupState } from '@/composables/setupState'
import { CUSTOMERS_IMPORT_TYPE, useImportRunTracker } from '@/helpers/importRunTracker'
import api from '@/store/api'


export default {
  __name: 'SetupCustomersStep',
  props: {
  data: { type: Object, default: () => ({}) }
},
  emits: ['import', 'navigate', 'done'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const { importType, status, running } = useImportRunTracker()
const { applyStep } = useSetupState((...args) => api.call(...args))

const skipping = ref(false)
const skipError = ref('')
const skipped = computed(() => Boolean(props.data.skipped))

// The POST answers with the step, like every other write in the drawer, so the
// badge and the progress bar move without going back for the whole state.
const skip = async () => {
  if (skipping.value) return
  skipping.value = true
  skipError.value = ''
  try {
    const response = await api.call('POST', 'setup/skip_customers', {}, { receive: false, redirectOnForbidden: false })
    applyStep(response.data)
    emit('done')
  } catch (error) {
    const errors = error && error.response && error.response.data && error.response.data.errors
    skipError.value =
      Array.isArray(errors) && errors.length
        ? errors.join('. ')
        : 'We could not skip that just now. Try again in a moment.'
  } finally {
    skipping.value = false
  }
}

const count = computed(() => Number(props.data.count) || 0)
// The tracker is shared with the products wizard, so the step only speaks for
// the import it is actually about.
const isCustomers = computed(() => importType.value === CUSTOMERS_IMPORT_TYPE)
const importing = computed(() => isCustomers.value && running.value)
const importFailed = computed(() => isCustomers.value && status.value === 'failed')
const importUnknown = computed(() => isCustomers.value && status.value === 'unknown')

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "m-0 text-sm leading-relaxed text-catering-ink-600" }, " Bottle works by texting your customers, and right now there is nobody to text. Bring your list over as a CSV and everyone lands in Customers, ready to hear from you. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(UsersIcon), {
        class: "h-[18px] w-[18px] flex-shrink-0 text-catering-ink-500",
        "aria-hidden": "true"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(count.value), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(count.value === 1 ? 'customer in your list' : 'customers in your list'), 1)
      ]),
      _createVNode(_unref(RouterLink), {
        to: "/lists",
        class: "text-sm font-semibold text-catering-tomato-600 underline underline-offset-2",
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('navigate')))
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Open Customers ", -1)
        ]))]),
        _: 1
      })
    ]),
    (importing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", {
            class: "import-spinner h-[18px] w-[18px] flex-shrink-0 rounded-full",
            "aria-hidden": "true"
          }, null, -1),
          _createElementVNode("div", { class: "min-w-0 flex-1" }, [
            _createElementVNode("span", { class: "block text-sm font-semibold text-catering-ink-900" }, "Bringing your customers in"),
            _createElementVNode("span", { class: "block text-xs text-catering-ink-600" }, " This keeps running while you carry on. The step ticks itself off when the list lands. ")
          ], -1)
        ]))]))
      : (importFailed.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " That import did not finish. Check your file and try it again. "))
        : (importUnknown.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " We stopped hearing back about that import. Open Customers to see whether your list arrived. "))
          : _createCommentVNode("", true),
    (skipError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(skipError.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      (!skipped.value && !count.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "cursor-pointer border-none bg-transparent p-0 text-sm font-semibold text-catering-ink-500 underline underline-offset-2 disabled:cursor-default",
            disabled: skipping.value || importing.value,
            onClick: skip
          }, _toDisplayString(skipping.value ? 'Skipping...' : 'Skip for now'), 9, _hoisted_11))
        : _createCommentVNode("", true),
      _createVNode(GlowFrame, {
        subtle: "",
        "frame-class": "inline-flex rounded-full"
      }, {
        default: _withCtx(() => [
          _createVNode(NeueButton, {
            type: "accent",
            disabled: importing.value,
            onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('import')))
          }, {
            "icon-right": _withCtx(() => [
              _createVNode(SwooshArrow, { class: "ml-1" })
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(count.value ? 'Import more customers' : 'Import your customers') + " ", 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    (skipped.value && !count.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, " You skipped this for now. Import whenever your list is ready - the button above still works. "))
      : _createCommentVNode("", true),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "m-0 text-xs leading-relaxed text-catering-ink-500" }, " A name and a mobile number per row is enough. You can tag the whole batch as you import it. ", -1))
  ]))
}
}

}